/* eslint-disable quote-props */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';

import { IconContext } from 'react-icons';
import {
  CgSortAz,
  CgOptions,
  CgChevronLeft,
  CgChevronRight,
} from 'react-icons/cg';
import { VscSearch } from 'react-icons/vsc';
import _, { last } from 'lodash';
import { useOutsideAlerter } from '../../../helpers/dom';

// ========= action import section ========= //
import {
  setDashboardCategory,
  setDashboardKeyword,
  setDashboardPage,
  setDashboardSort,
  setDashboardStatus,
} from '../../../actions/uiAction';
import DataUIInterface from '../../../interface/reducers/ui';
import {
  handleCategoryTextConverter,
  handleStatusTextConverter,
} from '../../../helpers/textConverter';
import DataHistoryInterface, {
  PembelianInterface,
  PenjualanInterface,
} from '../../../interface/reducers/history';
import DataOfferInterface, {
  OfferPendingInterface,
} from '../../../interface/reducers/offer';
// ====== end of action import section ====== //

// ========= interface import section ========= //
// ====== end of interface import section ====== //

const filterOffer = ['Active', 'Expired'];
const filterPending = ['Awaiting Payment', 'Awaiting Payment Approval'];
const filterInProgress = [
  'Awaiting Seller Confirmation',
  'Waiting for Seller to Deliver',
  'En route to Kick Avenue',
  'Authentication Process',
  'Proses Review',
  'Authentication Process - Success',
  'Delivery to Customer',
];
const filterHistory = [
  'Completed',
  'Refund Process',
  'Refund Completed',
  'Cancelled',
  'Failed',
];

type stateToProps = {
  dataUi: DataUIInterface;
  dataHistory: DataHistoryInterface;
  dataOffer: DataOfferInterface;
};

interface TableHeaderComponentInterface {
  getData: () => Promise<any>;
  setKeyword: (txt: string) => Promise<any>;
  setSort: (txt: string) => Promise<any>;
  setCategory: (txt: string) => Promise<any>;
  setStatus: (txt: string) => Promise<any>;
  setPage: (page: number) => Promise<any>;
  type?: 'offer' | 'pending' | 'in progress' | 'history' | 'current';
  mode?: 'buying' | 'selling';
  dataHistory: DataHistoryInterface;
  dataOffer: DataOfferInterface;
  isHoliday: boolean | null;
}

/**
 * Table Header Compoent tab for Buying and Selling User Dashboard section for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {TableHeaderComponentInterface} props for this component.
 * @return {JSX.Element}
 */
function TableHeaderComponent({
  setKeyword,
  setCategory,
  type,
  setSort,
  setStatus,
  setPage,
  dataHistory,
  dataOffer,
  mode,
  isHoliday,
}: TableHeaderComponentInterface): JSX.Element {
  const [firstRender, setFirstRender] = useState(true);
  const [isSortOpen, setSortOpen] = useState(false);
  const [isFilterOpen, setFilterOpen] = useState(false);

  // ============== Start of pagination ui handler ==============
  const [currentPage, setCurrentPage] = useState(1);
  const [previousPage, setPreviousPage] = useState(1);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [startCountingPagination, setStartCountingPagination] = useState(false);
  const [paginationData, setPaginationData] = useState<
    PembelianInterface | OfferPendingInterface | PenjualanInterface
  >({
    current_page: currentPage,
    error: null,
    isFetch: false,
    last_page: 0,
    per_page: 0,
    total: 0,
    total_transaction: 0,
    dataOfferPending: [],
  });
  useEffect(() => {
    if (mode === 'buying') {
      switch (type) {
        case 'offer':
          // set the pagination data
          setPaginationData(dataOffer.offerPending);
          break;
        case 'pending':
          // set the pagination data
          setPaginationData(dataHistory.pembelian);
          break;
        case 'in progress':
          // set the pagination data
          setPaginationData(dataHistory.pembelianProcessed);
          break;
        case 'history':
          // set the pagination data
          setPaginationData(dataHistory.pembelianCompleted);
          break;
        default:
          setPaginationData({
            current_page: currentPage,
            error: null,
            isFetch: false,
            last_page: 0,
            per_page: 0,
            total: 0,
            total_transaction: 0,
            dataOfferPending: [],
          });
          break;
      }
    } else {
      switch (type) {
        case 'current':
        case 'in progress':
        case 'history':
          setPaginationData(dataHistory.penjualan);
          break;
        default:
          setPaginationData({
            current_page: currentPage,
            error: null,
            isFetch: false,
            last_page: 0,
            per_page: 0,
            total: 0,
            total_transaction: 0,
            dataOfferPending: [],
          });
          break;
      }
    }
  }, [
    dataOffer.offerPending,
    dataHistory.pembelian,
    dataHistory.pembelianCompleted,
    dataHistory.pembelianProcessed,
    dataHistory.penjualan,
  ]);
  // ============ Logic for handling the pagination ============ //
  useEffect(() => {
    // On desktop, pagination number is up to 5 page
    // On Mobile, pagination number is only 3 page
    if (window.innerWidth > 1095) {
      if (currentPage > 2) {
        setStartCountingPagination(true);
      }

      if (!firstRender) {
        setPage(currentPage);
        const lastPage = paginationData.last_page;
        const lastIndexCondition = lastPage - currentPage;
        const lastIndexCalculation = currentPage - previousPage;
        const firstIndexCondition = currentPage - 2;
        const firstIndexCalculation = previousPage - currentPage;

        if (previousPage < currentPage) {
          if (startCountingPagination && lastIndexCondition <= 2) {
            setCurrentIndex(lastPage - 5);
          } else if (
            startCountingPagination &&
            lastIndexCondition > 1 &&
            firstIndexCondition > 1
          ) {
            setCurrentIndex(
              currentIndex +
                (lastIndexCalculation > 2 ? lastIndexCalculation - 2 : 1),
            );
          }
        } else {
          if (startCountingPagination && firstIndexCondition <= 1) {
            setCurrentIndex(0);
          } else if (
            startCountingPagination &&
            firstIndexCondition > 1 &&
            lastIndexCondition > 2
          ) {
            setCurrentIndex(
              currentIndex -
                (firstIndexCalculation > 2 ? firstIndexCalculation - 2 : 1),
            );
          }
        }
      }
    } else {
      if (currentPage > 1) {
        setStartCountingPagination(true);
      }

      if (!firstRender) {
        setPage(currentPage);
        const lastPage = paginationData.last_page;
        const lastIndexCondition = lastPage - currentPage;
        const lastIndexCalculation = currentPage - previousPage;
        const firstIndexCondition = currentPage - 1;
        const firstIndexCalculation = previousPage - currentPage;

        if (previousPage < currentPage) {
          setCurrentIndex(
            currentIndex +
              (lastIndexCalculation > 1 ? lastIndexCalculation - 1 : 1),
          );
        } else {
          setCurrentIndex(
            currentIndex -
              (firstIndexCalculation > 1 ? firstIndexCalculation - 1 : 1),
          );
        }
      }
    }
  }, [currentPage, startCountingPagination]);
  // ============ end of Logic for handling the pagination ============ //
  // ============== End of pagination ui handler ==============

  // ============== Start of sort ui handler ==============
  const [txt, setTxt] = useState('');
  const onChangeTxt = (e: any) => setTxt(e.target.value);

  const wrapperRefSort = useRef(null);
  const [currentSort, setCurrentSort] = useState('');
  const toggleSort = () => setSortOpen(!isSortOpen);
  useOutsideAlerter(wrapperRefSort, () => setSortOpen(false));
  // ============== End of sort ui handler ==============

  // ============== Start of filter ui handler ==============
  const wrapperRefFilter = useRef(null);
  const toggleFilter = () => setFilterOpen(!isFilterOpen);
  useOutsideAlerter(wrapperRefFilter, () => setFilterOpen(false));
  const [categorySelected, setCategorySelected] = useState({
    sneakers: false,
    apparel: false,
    luxury: false,
    toys: false,
    'local-brands': false,
  });
  const [statusSelected, setStatusSelected] = useState<any>({});

  // use effect for handling status filter for each buying and selling tabs
  useEffect(() => {
    if (mode === 'buying') {
      switch (type) {
        case 'offer':
          // set the status filter
          const dataStatusOffer: any = {};
          filterOffer.map((t) => (dataStatusOffer[t] = false));
          setStatusSelected(dataStatusOffer);
          break;
        case 'pending':
          // set the status filter
          const dataStatusPending: any = {};
          filterPending.map((t) => (dataStatusPending[t] = false));
          setStatusSelected(dataStatusPending);
          break;
        case 'in progress':
          // set the status filter
          const dataStatusInProgress: any = {};
          filterInProgress.map((t) => (dataStatusInProgress[t] = false));
          setStatusSelected(dataStatusInProgress);
          break;
        case 'history':
          // set the status filter
          const dataStatusHistory: any = {};
          filterHistory.map((t) => (dataStatusHistory[t] = false));
          setStatusSelected(dataStatusHistory);
          break;
        default:
          setStatusSelected({});
          break;
      }
    }
  }, [type]);

  const onChangeCategory = (val: boolean, key: string) => {
    setCategorySelected({
      ...categorySelected,
      [key]: val,
    });
  };
  const onChangeStatus = (val: boolean, key: string) => {
    setStatusSelected({
      ...statusSelected,
      [key]: val,
    });
  };
  // ============== End of filter ui handler ==============

  // helper to prevent instant search on component mount
  useEffect(() => {
    setTimeout(() => setFirstRender(false), 1000);
  }, []);
  useEffect(() => {
    if (!firstRender) setKeywordThenSearch(txt);
  }, [txt]);

  // ============== Function for triggering filter and sort search ==============
  // keyword search handler
  const setKeywordThenSearch = useCallback(
    _.debounce((t) => {
      setKeyword(t);
      setPage(1);
      setCurrentPage(1);
    }, 1000),
    [],
  );
  // sort search handler
  const doSortThenSearch = (sortBy: string) => {
    setCurrentSort(sortBy);
    toggleSort();
    setSort(sortBy);
  };
  // category filter search handler
  useEffect(() => {
    let selectedCategory = '';
    const selectedCategoryArray: string[] = [];
    Object.keys(categorySelected).forEach((t, index, array) => {
      if (categorySelected[t]) {
        selectedCategoryArray.push(handleCategoryTextConverter(t));
      }
      if (index === array.length - 1) {
        selectedCategory = selectedCategoryArray.join(',');
      }
    });
    setCategory(selectedCategory);
    setPage(1);
    setCurrentPage(1);
  }, [categorySelected]);
  // status filter search handler
  useEffect(() => {
    let selectedStatus = '';
    const selectedStatusArray: string[] = [];
    Object.keys(statusSelected).forEach((t, index, array) => {
      if (statusSelected[t]) {
        selectedStatusArray.push(handleStatusTextConverter(t));
      }
      if (index === array.length - 1) {
        selectedStatus = selectedStatusArray.join(',');
      }
    });
    if (!firstRender) setStatus(selectedStatus);
  }, [statusSelected]);
  // ============== end of Function for triggering filter and sort search ==============

  // ============== component for rendering sort option ============== //
  const renderSortChild = () => {
    if (mode === 'buying') {
      switch (type) {
        case 'offer':
          return renderOfferSort();
        case 'pending':
          return renderPendingSort();
        case 'in progress':
          return renderInProgressSort();
        case 'history':
          return renderHistorySort();
        default:
          break;
      }
    } else {
      switch (type) {
        case 'current':
          return renderCurrentSellingSort();
        case 'in progress':
          return renderInProgressSellingSort();
        case 'history':
          return renderHistorySellingSort();
        default:
          break;
      }
    }
  };
  const renderCurrentSellingSort = () => {
    if (isSortOpen) {
      return (
        <div className={`sort-pop-up`}>
          <div
            className={`sort-item ${
              currentSort === 'createdAt_desc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('createdAt_desc')}
          >
            Latest
          </div>
          <div
            className={`sort-item ${
              currentSort === 'createdAt_asc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('createdAt_asc')}
          >
            Earliest
          </div>
          <div
            className={`sort-item ${
              currentSort === 'askingPrice_asc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('askingPrice_asc')}
          >
            Lowest Price
          </div>
          <div
            className={`sort-item last ${
              currentSort === 'askingPrice_desc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('askingPrice_desc')}
          >
            Highest Price
          </div>
        </div>
      );
    }
    return <div />;
  };
  const renderInProgressSellingSort = () => {
    if (isSortOpen) {
      return (
        <div className={`sort-pop-up`}>
          <div
            className={`sort-item ${
              currentSort === 'createdAt_desc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('createdAt_desc')}
          >
            Latest
          </div>
          <div
            className={`sort-item ${
              currentSort === 'createdAt_asc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('createdAt_asc')}
          >
            Earliest
          </div>
        </div>
      );
    }
    return <div />;
  };
  const renderHistorySellingSort = () => {
    if (isSortOpen) {
      return (
        <div className={`sort-pop-up`}>
          <div
            className={`sort-item ${
              currentSort === 'createdAt_desc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('createdAt_desc')}
          >
            Latest
          </div>
          <div
            className={`sort-item ${
              currentSort === 'createdAt_asc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('createdAt_asc')}
          >
            Earliest
          </div>
          <div
            className={`sort-item ${
              currentSort === 'price_asc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('price_asc')}
          >
            Lowest Revenue
          </div>
          <div
            className={`sort-item last ${
              currentSort === 'price_desc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('price_desc')}
          >
            Highest Revenue
          </div>
        </div>
      );
    }
    return <div />;
  };
  const renderOfferSort = () => {
    if (isSortOpen) {
      return (
        <div className={`sort-pop-up`}>
          <div
            className={`sort-item ${
              currentSort === 'createdAt_desc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('createdAt_desc')}
          >
            Latest
          </div>
          <div
            className={`sort-item ${
              currentSort === 'createdAt_asc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('createdAt_asc')}
          >
            Earliest
          </div>
          <div
            className={`sort-item ${
              currentSort === 'amount_asc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('amount_asc')}
          >
            Lowest Offer
          </div>
          <div
            className={`sort-item last ${
              currentSort === 'amount_desc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('amount_desc')}
          >
            Highest Offer
          </div>
        </div>
      );
    }
    return <div />;
  };
  const renderPendingSort = () => {
    if (isSortOpen) {
      return (
        <div className={`sort-pop-up`}>
          <div
            className={`sort-item ${
              currentSort === 'createdAt_desc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('createdAt_desc')}
          >
            Latest
          </div>
          <div
            className={`sort-item last ${
              currentSort === 'createdAt_asc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('createdAt_asc')}
          >
            Earliest
          </div>
        </div>
      );
    }
    return <div />;
  };
  const renderInProgressSort = () => {
    if (isSortOpen) {
      return (
        <div className={`sort-pop-up`}>
          <div
            className={`sort-item ${
              currentSort === 'createdAt_desc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('createdAt_desc')}
          >
            Latest
          </div>
          <div
            className={`sort-item last ${
              currentSort === 'createdAt_asc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('createdAt_asc')}
          >
            Earliest
          </div>
        </div>
      );
    }
    return <div />;
  };
  const renderHistorySort = () => {
    if (isSortOpen) {
      return (
        <div className={`sort-pop-up`}>
          <div
            className={`sort-item ${
              currentSort === 'createdAt_desc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('createdAt_desc')}
          >
            Latest
          </div>
          <div
            className={`sort-item last ${
              currentSort === 'createdAt_asc' ? 'active' : ''
            }`}
            onClick={() => doSortThenSearch('createdAt_asc')}
          >
            Earliest
          </div>
        </div>
      );
    }
    return <div />;
  };
  // ============== end of component for rendering sort option ============== //

  // ============== component for rendering filter option ============== //
  const renderFilterChild = () => {
    if (mode === 'buying') {
      switch (type) {
        case 'offer':
          return renderOfferFilter();
        case 'pending':
          return renderPendingFilter();
        case 'in progress':
          return renderInProgressFilter();
        case 'history':
          return renderHistoryFilter();
        default:
          return <div />;
      }
    } else {
      // switch (type) {
      //   case 'current':
      //     return renderOfferFilter();
      //   default:
      //     return <div />;
      // }
    }
  };
  const renderOfferFilter = () => {
    return (
      <div className={'filter-item-category'}>
        {/* <p className={'title'}>Expiry</p>
        {filterOffer.map((item, index) => {
          return (
            <div className={'filter-item'} key={index}>
              <div className="pretty p-svg p-curve">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    onChangeStatus(e.target.checked, item);
                  }}
                  checked={statusSelected[item]}
                />
                <div className="state">
                  <svg className="svg svg-icon" viewBox="0 0 20 20">
                    <path
                      d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                      style={{ stroke: 'white', fill: 'white' }}
                    ></path>
                  </svg>
                  <label>{item}</label>
                </div>
              </div>
            </div>
          );
        })} */}
      </div>
    );
  };
  const renderPendingFilter = () => {
    return (
      <div className={'filter-item-category'}>
        <p className={'title'}>Status</p>
        {filterPending.map((item, index) => {
          return (
            <div className={'filter-item'} key={index}>
              <div className="pretty p-svg p-curve">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    onChangeStatus(e.target.checked, item);
                  }}
                  checked={statusSelected[item]}
                />
                <div className="state">
                  <svg className="svg svg-icon" viewBox="0 0 20 20">
                    <path
                      d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                      style={{ stroke: 'white', fill: 'white' }}
                    ></path>
                  </svg>
                  <label>{item}</label>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };
  const renderInProgressFilter = () => {
    return (
      <div className={'filter-item-category'}>
        <p className={'title'}>Status</p>
        {filterInProgress.map((item, index) => {
          return (
            <div className={'filter-item'} key={index}>
              <div className="pretty p-svg p-curve">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    onChangeStatus(e.target.checked, item);
                  }}
                  checked={statusSelected[item]}
                />
                <div className="state">
                  <svg className="svg svg-icon" viewBox="0 0 20 20">
                    <path
                      d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                      style={{ stroke: 'white', fill: 'white' }}
                    ></path>
                  </svg>
                  <label>{item}</label>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };
  const renderHistoryFilter = () => {
    return (
      <div className={'filter-item-category'}>
        <p className={'title'}>Status</p>
        {filterHistory.map((item, index) => {
          return (
            <div className={'filter-item'} key={index}>
              <div className="pretty p-svg p-curve">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    onChangeStatus(e.target.checked, item);
                    setCurrentPage(1);
                  }}
                  checked={statusSelected[item]}
                />
                <div className="state">
                  <svg className="svg svg-icon" viewBox="0 0 20 20">
                    <path
                      d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                      style={{ stroke: 'white', fill: 'white' }}
                    ></path>
                  </svg>
                  <label>{item}</label>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };
  const renderFilter = () => {
    if (isFilterOpen) {
      return (
        <div className={`filter-pop-up`}>
          <div className={'filter-item-category'}>
            <p className={'title'}>Category</p>
            <div className={'filter-item'}>
              <div className="pretty p-svg p-curve">
                <input
                  type="checkbox"
                  checked={categorySelected.sneakers}
                  onChange={(e) => {
                    onChangeCategory(e.target.checked, 'sneakers');
                  }}
                />
                <div className="state">
                  <svg className="svg svg-icon" viewBox="0 0 20 20">
                    <path
                      d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                      style={{ stroke: 'white', fill: 'white' }}
                    ></path>
                  </svg>
                  <label>Sneakers</label>
                </div>
              </div>
            </div>
            <div className={'filter-item'}>
              <div className="pretty p-svg p-curve">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    onChangeCategory(e.target.checked, 'apparel');
                  }}
                  checked={categorySelected.apparel}
                />
                <div className="state">
                  <svg className="svg svg-icon" viewBox="0 0 20 20">
                    <path
                      d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                      style={{ stroke: 'white', fill: 'white' }}
                    ></path>
                  </svg>
                  <label>Apparel</label>
                </div>
              </div>
            </div>
            <div className={'filter-item'}>
              <div className="pretty p-svg p-curve">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    onChangeCategory(e.target.checked, 'luxury');
                  }}
                  checked={categorySelected.luxury}
                />
                <div className="state">
                  <svg className="svg svg-icon" viewBox="0 0 20 20">
                    <path
                      d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                      style={{ stroke: 'white', fill: 'white' }}
                    ></path>
                  </svg>
                  <label>Luxury</label>
                </div>
              </div>
            </div>
            <div className={'filter-item'}>
              <div className="pretty p-svg p-curve">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    onChangeCategory(e.target.checked, 'toys');
                  }}
                  checked={categorySelected.toys}
                />
                <div className="state">
                  <svg className="svg svg-icon" viewBox="0 0 20 20">
                    <path
                      d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                      style={{ stroke: 'white', fill: 'white' }}
                    ></path>
                  </svg>
                  <label>Electronics & Collectibles</label>
                </div>
              </div>
            </div>
            <div className={'filter-item'}>
              <div className="pretty p-svg p-curve">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    onChangeCategory(e.target.checked, 'local-brands');
                  }}
                  checked={categorySelected['local-brands']}
                />
                <div className="state">
                  <svg className="svg svg-icon" viewBox="0 0 20 20">
                    <path
                      d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                      style={{ stroke: 'white', fill: 'white' }}
                    ></path>
                  </svg>
                  <label>Made in Indonesia</label>
                </div>
              </div>
            </div>
          </div>
          {renderFilterChild()}
        </div>
      );
    }
    return <div />;
  };
  // ============== end of component for rendering filter option ============== //

  // ============== component for rendering pagination ============== //
  // const renderPagination = (paginationData: PembelianInterface | OfferPendingInterface) => {
  const renderPagination = () => {
    const arrayOfNumberPagination = new Array(
      paginationData.last_page === 0 ? 1 : paginationData.last_page,
    )
      .fill(1)
      .map((value, index) => index + 1);
    const lastPage = arrayOfNumberPagination.length;
    let newArrayPagination =
      window.innerWidth > 1095
        ? lastPage < 6
          ? arrayOfNumberPagination
          : arrayOfNumberPagination.slice(currentIndex, currentIndex + 5)
        : lastPage < 4
        ? arrayOfNumberPagination
        : arrayOfNumberPagination.slice(
            currentIndex === 0 ? 0 : currentIndex - 1,
            currentIndex === 0 ? 3 : currentIndex + 2,
          );

    const handleNextPage = () => {
      if (currentPage !== lastPage) {
        setPreviousPage(currentPage);
        setCurrentPage(currentPage + 1);
      }
    };
    const handlePrevPage = () => {
      if (currentPage !== 1) {
        setPreviousPage(currentPage);
        setCurrentPage(currentPage - 1);
      }
    };

    return (
      <>
        <IconContext.Provider value={{ color: '#242424', size: '14px' }}>
          <div className={'pagination-control'} onClick={handlePrevPage}>
            <CgChevronLeft />
          </div>
        </IconContext.Provider>
        {isHoliday ? (
          <div className={'pagination-item-active'} key={1}>
            1
          </div>
        ) : (
          newArrayPagination.map((v, i) => {
            if (!v) return;
            const onClick = () => {
              if (v !== currentPage && typeof v === 'number') {
                setPreviousPage(currentPage);
                setCurrentPage(v);
              }
            };
            return (
              <div
                className={
                  v === currentPage
                    ? 'pagination-item-active'
                    : 'pagination-item'
                }
                key={i}
                onClick={onClick}
              >
                {v}
              </div>
            );
          })
        )}
        <IconContext.Provider value={{ color: '#242424', size: '14px' }}>
          <div className={'pagination-control'} onClick={handleNextPage}>
            <CgChevronRight />
          </div>
        </IconContext.Provider>
      </>
    );
  };
  // ============== end of component for rendering pagination ============== //

  return (
    <div className={'table-header-container'}>
      <div className={'search-container'}>
        <IconContext.Provider value={{ color: '#242424', size: '17px' }}>
          <div>
            <VscSearch />
          </div>
        </IconContext.Provider>
        <input
          type={'text'}
          placeholder={
            mode === 'buying'
              ? `Search your buying ${type} here`
              : `Search your listings here`
          }
          className={'input-text'}
          onChange={onChangeTxt}
        />
      </div>
      <div className={'sort-container'} ref={wrapperRefSort}>
        <div className={'sort-parent'} onClick={toggleSort}>
          <IconContext.Provider value={{ color: '#242424', size: '20px' }}>
            <div>
              <CgSortAz />
            </div>
          </IconContext.Provider>
          <span className={'text'}>Sort</span>
        </div>
        {renderSortChild()}
      </div>
      <div className={'filter-container'} ref={wrapperRefFilter}>
        <div className={'filter-parent'} onClick={toggleFilter}>
          <IconContext.Provider value={{ color: '#242424', size: '20px' }}>
            <div>
              <CgOptions />
            </div>
          </IconContext.Provider>
          <span className={'text'}>Filter</span>
        </div>
        {renderFilter()}
      </div>
      <div className={'pagination-container'}>{renderPagination()}</div>
    </div>
  );
}

const mapStateToProps = (state: stateToProps) => {
  return {
    dataHistory: state.dataHistory,
    dataOffer: state.dataOffer,
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    setKeyword: (text: string) => dispatch(setDashboardKeyword(text)),
    setSort: (text: string) => dispatch(setDashboardSort(text)),
    setCategory: (text: string) => dispatch(setDashboardCategory(text)),
    setStatus: (text: string) => dispatch(setDashboardStatus(text)),
    setPage: (page: number) => dispatch(setDashboardPage(page)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableHeaderComponent);
